export const ANIMATION_LIST = {
  hoverTranlationLeft: 'hover-tranlation-left',
  hoverTranlationRight: 'hover-tranlation-right',
  hoverTranlationUp: 'hover-tranlation-up',
  hoverTranlationDown: 'hover-tranlation-down',
  hoverScale: 'hover-scale',
  fadeIn: 'fade-in',
  fadeInLeft: 'fade-in-left',
  fadeInRight: 'fade-in-right',
  fadeInDown: 'fade-in-down',
  fadeInUp: 'fade-in-up',
  fadeOut: 'fade-out',
  fadeOutLeft: 'fade-out-left',
  fadeOutRight: 'fade-out-right',
  fadeOutDown: 'fade-out-down',
  fadeOutUp: 'fade-out-up',
  slideInLeft: 'slide-in-left',
  slideInRight: 'slide-in-right',
  slideInDown: 'slide-in-down',
  slideInUp: 'slide-in-up',
  slideOutLeft: 'slide-out-left',
  slideOutRight: 'slide-out-right',
  slideOutDown: 'slide-out-down',
  slideOutUp: 'slide-out-up',
  zoomIn: 'zoom-in',
  zoomOut: 'zoom-out',
  zoomInLeft: 'zoom-in-left',
  zoomInRight: 'zoom-in-right',
  zoomInDown: 'zoom-in-down',
  zoomInUp: 'zoom-in-up',
  zoomOutLeft: 'zoom-out-left',
  zoomOutRight: 'zoom-out-right',
  zoomOutDown: 'zoom-out-down',
  zoomOutUp: 'zoom-out-up',
  flipInX: 'flip-in-x',
  flipInY: 'flip-in-y',
  flipOutX: 'flip-out-x',
  flipOutY: 'flip-out-y',
  lightSpeedInLeft: 'light-speed-in-left',
  lightSpeedOutLeft: 'light-speed-out-left',
  lightSpeedInRight: 'light-speed-in-right',
  lightSpeedOutRight: 'light-speed-out-right',
  rotateLeft: 'rotate-left',
  rotateRight: 'rotate-right',
  rotateLeftBack: 'rotate-left-back',
  rotateRightBack: 'rotate-right-back',
  rotateLeftFade: 'rotate-left-fade',
  rotateRightFade: 'rotate-right-fade',
  rotateLeftBackFade: 'rotate-left-back-fade',
  rotateRightBackFade: 'rotate-right-back-fade',
  bounce: 'bounce',
  rubberBand: 'rubber-band',
  heartBeat: 'heart-beat',
  swing: 'swing',
  spin: 'spin',
  blink: 'blink'
}
